export enum AdapterType {
  Rubicon = 1,
  Epsilon = 2,
  None = 3,
  InMobi = 4
}
